import MongoCollection from './MongoCollection'
import Activity from './Activity'

export default class Activities extends MongoCollection {
  model () {
    return Activity
  }

  routes () {
    return {
      fetch: 'activities'
    }
  }
}
